import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CButton from '@/components/shared/CButton';
import CFileInput from '@/components/shared/CFileInput';


export default /*#__PURE__*/_defineComponent({
  __name: 'CImageUploadRow',
  props: {
    value: { default: () => [] },
    imageUrl: null,
    name: null,
    placeholder: { default: 'Upload Image' },
    hint: null,
    accept: { default: '.png,.jpg,.jpeg,.webp' },
    maxMbSize: { default: 10 },
    disabled: { type: Boolean },
    removable: { type: Boolean }
  },
  emits: ["input", "remove"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: File[]): void;
    (event: 'remove'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: File[], imageUrl?: string, name?: string, placeholder: string, hint?: string, accept: string, maxMbSize: number, disabled?: boolean, removable?: boolean };





const defaultHint = computed(() => {
    const extensions = props.accept
        .split(',')
        .map((extension) => extension.trim().replace(/^\./, '').toUpperCase())
        // jpg/jpeg is the same format for the user, only the shorter one is worth showing
        .filter((extension) => extension !== 'JPEG');

    return `${extensions.join(', ')} - Max ${props.maxMbSize}MB`;
});

return { __sfc: true,props, emit, defaultHint, CButton, CFileInput }
}

})